import React from 'react';
import PropTypes from 'prop-types';

import { ProductImage } from '../../product-image';
import { CloseIcon } from './img';
import styles from './ProductCompareCard.css';

const IPropTypes = {
  className: PropTypes.string,
  product: PropTypes.shape({
    id: PropTypes.string.isRequired,
    financing: PropTypes.shape({
      priceString: PropTypes.string.isRequired,
    }).isRequired,
    coverImage: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  }).isRequired,
  onDeletionClick: PropTypes.func,
};

const defaultProps = {
  className: '',
  onDeletionClick: () => {},
};

const ProductCompareCard = props => (
  <div className={[styles.container, props.className].join(' ')}>
    <ProductImage
      className={styles.image}
      src={props.product.coverImage}
      size="sm"
    />
    <div className={styles.infoContainer}>
      <span className={styles.name}>{props.product.name}</span>
      <span className={styles.price}>${props.product.financing.priceString}</span>
    </div>
    <button
      className={styles.deleteButton}
      onClick={() => props.onDeletionClick(props.product.id)}
    >
      <img className={styles.deleteIcon} src={CloseIcon} alt="" />
    </button>
  </div>
);

ProductCompareCard.propTypes = IPropTypes;
ProductCompareCard.defaultProps = defaultProps;

export { ProductCompareCard };



// WEBPACK FOOTER //
// ./src/common/compare-section/product-compare-card/ProductCompareCard.jsx